var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('a',{attrs:{"href":_vm.editUrl}},[_vm._v("Edit This")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }